/* eslint-disable @next/next/no-img-element */
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { toTitleCase } from "common";
import ShopLayout1 from "components/layouts/ShopLayout1";
import LazyImage from "components/LazyImage";
import { H2, H3 } from "components/Typography";
import { useAppDispatch } from "hooks/use-app-dispatch";
import { useAppSelector } from "hooks/use-app-selector";
import useResolution from "hooks/useResolution";
import modules from "modules";
import { useRouter } from "next/router";
import React, { FC, useEffect } from "react";

const { actions: brandsActions, selectors: brandsSelectors } = modules.brands;

const BrandList: FC = () => {
  const { lg, md, sm } = useResolution();
  const dispatch = useAppDispatch();
  const { push } = useRouter();

  const brands = useAppSelector(brandsSelectors.selectBrands);
  const isLoading = useAppSelector(brandsSelectors.selectIsLoading);

  const getBrands = () => {
    dispatch(brandsActions.getActiveBrandsThunk());
  };

  const onClickBrand = (slug: string) => {
    push(`/brands/${slug}`);
  };

  useEffect(() => {
    !brands?.[0] ? getBrands() : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ShopLayout1>
      <Container sx={{ mt: sm ? "1em" : md ? "6em" : "5em", mb: "10em" }}>
        {brands?.[0] && !isLoading ? (
          <H2 fontWeight="bold" lineHeight="1" mb="1em">
            Brands
          </H2>
        ) : null}
        {lg ? (
          <Grid container spacing={2}>
            {!isLoading && brands?.[0] ? (
              brands.map((b, ind) => (
                <Grid
                  item
                  xs={12}
                  key={ind}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  onClick={() => onClickBrand(b?.slug)}
                >
                  <img
                    alt={b?.name}
                    style={{
                      width: undefined,
                      height: "100%",
                      maxHeight: lg ? "2em" : "3em",
                    }}
                    src={b?.icon_url || "/assets/images/sad_red_hair.png"}
                  />
                  <Typography>{toTitleCase(b.name)}</Typography>
                </Grid>
              ))
            ) : (
              <Container
                sx={{ display: "flex", justifyContent: "center", mt: 5 }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <LazyImage
                    src={"/assets/images/kachi/kachi-exciting.png"}
                    width={300}
                    height={300}
                    loading="eager"
                    objectFit="contain"
                  />
                  <H3 sx={{ marginTop: "1em" }}>
                    Exciting things are in the work!
                  </H3>
                </Box>
              </Container>
            )}
          </Grid>
        ) : (
          <Grid container spacing={1}>
            {!isLoading && brands?.[0] ? (
              brands.map((b, ind) => (
                <Grid item xs={2} key={ind}>
                  <Button
                    fullWidth
                    onClick={() => onClickBrand(b?.slug)}
                    sx={{
                      background: "white",
                      minHeight: "7em",
                      pb: ".1em",
                      textTransform: "none",
                      padding: "20px 60px",
                      border: "1px solid #aeb4be",
                      borderRadius: "4px",
                    }}
                  >
                    <img
                      alt={b?.name}
                      style={{
                        width: undefined,
                        height: "100%",
                        maxHeight: lg ? "2em" : "3em",
                      }}
                      src={b?.icon_url || "/assets/images/sad_red_hair.png"}
                    />
                  </Button>
                </Grid>
              ))
            ) : (
              <Container style={{ display: "flex", justifyContent: "center" }}>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <LazyImage
                    src={"/assets/images/kachi/kachi-exciting.png"}
                    width={300}
                    height={300}
                    loading="eager"
                    objectFit="contain"
                  />
                  <H3 sx={{ marginTop: "1em" }}>
                    Exciting things are in the work!
                  </H3>
                </Box>
              </Container>
            )}
          </Grid>
        )}

        {isLoading && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: "2em" }}>
            <CircularProgress size={80} />
          </Box>
        )}
      </Container>
    </ShopLayout1>
  );
};

export default BrandList;
